import {
	PlanReviewFindingFeedbackRow,
	feedbackDecisionLabel,
	feedbackReasonLabel,
	formatPersonWithOrganization,
	formatReviewDateTime
} from "utils/plan-review-finding-review";

interface PlanReviewApplicantFeedbackCardProps {
	feedback: PlanReviewFindingFeedbackRow;
	/** "highlighted" is the indigo box of the finding modal; "plain" is the white box of a comment letter card. */
	appearance: "highlighted" | "plain";
}

/** The latest feedback that the applicant wrote on a finding: rating, author, date, reason and comment. */
const PlanReviewApplicantFeedbackCard = ({ feedback, appearance }: PlanReviewApplicantFeedbackCardProps) => {
	const reasonLabel = feedbackReasonLabel(feedback.reason);

	return (
		<div className={`prafc prafc-${appearance}`}>
			<div className="prafc-head">
				<span className="prafc-title">
					Applicant Feedback
					<span className="prafc-rating">{feedbackDecisionLabel(feedback.decision)}</span>
				</span>
				<span className="prafc-meta">
					{formatPersonWithOrganization(feedback.user_name, feedback.organization_name)} ·{" "}
					{formatReviewDateTime(feedback.created_at)}
				</span>
			</div>
			{reasonLabel && <div className="prafc-reason">Reason: {reasonLabel}</div>}
			{feedback.comment && <div className="prafc-comment">“{feedback.comment}”</div>}
		</div>
	);
};

export default PlanReviewApplicantFeedbackCard;
